<template>
  <main class="mt-5">
    <div class="card mt-3">
      <div
        class="card-header align-items-center justify-content-between border-0"
      >
        <h5 class="card-title font-bold">
          گزارش مشتریان به همراه سطح و امتیازات دریافتی
        </h5>
        <ExcelDownload
          v-if="items && items.data && items.data.length"
          :post_method="true"
          :param="extraQuery"
          url="admin/customers_club/level_users"
        />
      </div>

      <div class="card-body">
        <div>
          <b-form
            class="row align-items-center"
            @submit.prevent="loadUserPointsAndLevelsList"
          >
            <div class="col-md-3">
              <b-form-group>
                <label for="">انتخاب مشتری</label>
                <CustomerSearch
                  v-model="form.selectedCustomer"
                  :allow-empty="true"
                  :show-label="false"
                />
              </b-form-group>
            </div>
            <div class="col-md-3 mb-4">
              <b-form-group>
                <label for=""> تاریخ شروع</label>
                <date-picker
                  type="date"
                  v-model="form.from_date"
                  format="YYYY-MM-DD"
                  display-format="jYYYY-jMM-jDD"
                />
              </b-form-group>
            </div>
            <div class="col-md-3 mb-4">
              <b-form-group>
                <label for=""> تاریخ پایان</label>
                <date-picker
                  type="date"
                  v-model="form.to_date"
                  format="YYYY-MM-DD"
                  display-format="jYYYY-jMM-jDD"
                />
              </b-form-group>
            </div>
            <div class="col-md-2 mb-1">
              <button
                :disabled="disabled"
                class="btn btn-primary"
                type="submit"
              >
                نمایش گزارشات
              </button>
            </div>
          </b-form>
        </div>
        <b-table
          :style="{ opacity: disabled ? '0.6' : 1 }"
          bordered
          responsive
          striped
          v-if="items && items.data && items.data.length"
          :fields="fields"
          :items="items.data"
        >
          <template v-slot:cell(index)="data">
            {{ data.index + 1 }}
          </template>
          <template v-slot:cell(full_name)="data">
            {{ data.item.full_name }}
          </template>
          <template v-slot:cell(mobile)="data">
            {{ data.item.mobile }}
          </template>
          <template v-slot:cell(customers_club_level)="data">
            {{ data.item.customers_club_level.level }}
          </template>
          <template v-slot:cell(customers_club_score)="data">
            {{ data.item.customers_club_score | price }}
          </template>
          <template v-slot:cell(customers_club_bon)="data">
            {{ data.item.customers_club_bon }}
          </template>
        </b-table>
        <div v-else class="alert alert-info">
          در صورتی که مشتری انتخاب نشود لیست همه گزارشات نمایش داده می شود
        </div>
        <pagination
          v-if="items && items.data && items.data.length"
          :disabled="disabled"
          :limit="2"
          :data="items"
          @pagination-change-page="changePage"
        >
        </pagination>
      </div>
    </div>
  </main>
</template>
<script>
import PointsAndLevelImpl from "@@/core/pages/customerClub/clubReports/pointsAndLevel/PointsAndLevelImpl.js";
export default {
  extends: PointsAndLevelImpl,
};
</script>
